module.exports = __webpack_public_path__ + "img/icons3.c4286342.png";